import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteVendor } from "api/vendor.api";
import { invalidateVendorSide } from "lib/cacheInvalidation";

export const useDeleteVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteVendor,
    onSuccess: () => invalidateVendorSide(queryClient),
  });
};
